module.exports = __webpack_public_path__ + "static/media/battery_eng_05.cb7c263e.png";